/**
 * @file 撤回任务
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IRevokeTaskOutput {
    status: number;
}

export interface IRevokeTaskInput {
    task_id: number; // int，任务编号
    obj_id: number; // int, 必填，对象ID，program_id/group_id/session_id
    obj_type: number; // int, 必填，对象类型 1：课程；2：课程小节；3：学习项目
}

export const revokeTask = (data: IRevokeTaskInput): Promise<IRevokeTaskOutput> => {
    return fetchData(Api.CLASS_REVOKE_TASK, data).then((res: IResponse<IRevokeTaskOutput>) => {
        return res.data as IRevokeTaskOutput;
    });
};
